import {
  SCREENER_FACILITY_VIEW_KIND,
  SCREENER_ROUTES_WITH_ALL_FACILITIES_SUPPORT,
  useScreenerFacilityView
} from '@/hooks/facility-selection/useScreenerFacilityView';

export const SCREENER_ALL_FACILITIES_PARAM = 'all_facilities';

export { SCREENER_ROUTES_WITH_ALL_FACILITIES_SUPPORT };

const useIsScreenerAllFacilitiesSelected = () => {
  const { view } = useScreenerFacilityView();
  return view.kind === SCREENER_FACILITY_VIEW_KIND.AllFacilities;
};

export default useIsScreenerAllFacilitiesSelected;
